import { Chip, Typography } from "@mui/material"
import type { FC } from "react"

interface CarrierChipProps {
  name: string | null | undefined
}

export const CarrierChip: FC<CarrierChipProps> = ({ name }) => {
  if (!name) return <Typography variant='body2'>-</Typography>

  return <Chip label={name} size='small' className='h-6 rounded bg-gray-300 px-1 text-xs text-gray-700' />
}
